<template>
  <div class="content">
    <title-bar :title="$lang.common_txt21"></title-bar>
    <div class="d-flex f-t-15 f-w font-color">
      <p
        class="message-i"
        v-for="(item, index) in [$lang.common_txt23]"
        :key="index"
        :class="{ active: selectIndex === index }"
        @click="getSelect(index)"
      >
        {{ item }}
      </p>
    </div>
    <p class="message-line"></p>
    <!-- <img src="../../../assets/img/common/bg-service.png" width="100%" /> -->

    <div v-if="selectIndex === 0" style="width: 96%; margin: 20px auto 0">
      <div
        class="message-i2 d-flex-s m-b-10"
        v-for="(item2, index2) in vipLevel > 2
          ? serviceList
          : serviceList.slice(0, 1)"
        :key="index2"
        @click="goTo(index2)"
      >
        <div class="d-flex">
          <img :src="item2.img" width="50" class="m-r-10" />
          <div>
            <p class="f-t-14 f-w">{{ item2.txt }}</p>
            <p class="font-color m-t-5">{{ item2.txt }}</p>
          </div>
        </div>
        <div class="font-color f-w ser-cont">{{ $lang.common_txt22 }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetCsLink, Init } from '@/api/common'
import {
  isOkResponse,
  safeContent,
} from '@/views/layout/safeLayout'
import {
  customerServiceFailMessage,
  openCustomerServiceUrl,
  resolveCustomerServiceLink,
  resolveCustomerServiceUrl
} from '@/views/layout/csLink'

const CUSTOMER_SERVICE_BLOCKED_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
const GENERIC_FAILURE_MARKER_RE = /readFailure|read_failure|readFailed|read_failed|dataUnavailable|data_unavailable|fallbackUsed|fallback_used|backendBlocked|backend_blocked|backendFailure|backend_failure|technicalMarker|technical_marker|technicalError|technical_error|technicalException|technical_exception|readOnly|read_only|need_login/i
// Legacy contract sentinel: this.$toast({ message: customerServiceFailMessage(data, this.$lang.common_txt114 || 'Request failed'), icon: 'cross' })

function hasGenericFailureMarker(data) {
  try {
    return GENERIC_FAILURE_MARKER_RE.test(JSON.stringify(data || {}))
  } catch (e) {
    return false
  }
}

export default {
  name: 'MessageCenter',
  components: {},
  data() {
    return {
      vipLevel: 0,
      selectIndex: 0,
      serviceList: [
        {
          img: require('@/assets/img/common/tt_icon.png'),
          txt: 'VUKAVI | Official Channel'
        },
        {
          img: require('@/assets/img/common/tt_icon.png'),
          txt: 'VUKAVI | Finance Channel'
        },
        {
          img: require('@/assets/img/common/whats-w.png'),
          txt: 'VUKAVI | Finance Channel'
        }
      ]
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.token) {
      this.Init()
    }
  },
  methods: {
    async GetCsLink(v) {
      try {
        const data = await GetCsLink()
        const link = resolveCustomerServiceLink(data, v)
        if (hasGenericFailureMarker(data) || !isOkResponse(data)) {
          this.$toast({ message: customerServiceFailMessage(data, CUSTOMER_SERVICE_BLOCKED_MESSAGE), icon: 'cross' })
          return null
        }
        if (!link.ok) {
          this.$toast({ message: customerServiceFailMessage(data, CUSTOMER_SERVICE_BLOCKED_MESSAGE), icon: 'cross' })
          return null
        }
        const url = link.url
        openCustomerServiceUrl(data, v)
        return url
      } catch (e) {
        this.$toast({ message: customerServiceFailMessage(e && (e.response || e), CUSTOMER_SERVICE_BLOCKED_MESSAGE), icon: 'cross' })
      }
    },
    getServiceUrl(data, type) {
      return resolveCustomerServiceUrl(data, type)
    },
    getSelect(i) {
      this.selectIndex = i
    },
    goTo(i) {
      if (i === 0) {
        this.openService('official')
      } else if (i === 1) {
        this.openService('telegram')
      } else if (i === 2) {
        this.openService('whatsapp')
      }
    },
    async openService(serviceType) {
      let data = null
      try {
        data = await GetCsLink()
        if (hasGenericFailureMarker(data) || !isOkResponse(data)) {
          this.$toast({ message: customerServiceFailMessage(data, CUSTOMER_SERVICE_BLOCKED_MESSAGE), icon: 'cross' })
          return
        }
        const opened = openCustomerServiceUrl(data, serviceType)
        if (opened) return
        this.$toast({ message: customerServiceFailMessage(data, CUSTOMER_SERVICE_BLOCKED_MESSAGE), icon: 'cross' })
      } catch (e) {
        this.$toast({ message: customerServiceFailMessage(e && (e.response || e), CUSTOMER_SERVICE_BLOCKED_MESSAGE), icon: 'cross' })
      }
    },
    async Init() {
      try {
        const data = await Init()
        if (isOkResponse(data)) {
          this.vipLevel = Number(safeContent(data).vipLevel) || 0
        }
      } catch (e) {
        this.vipLevel = 0
      }
    }
  }
}
</script>
<style lang="less" scoped>
.message-i {
  text-align: center;
  min-width: 85px;
  padding: 15px 0;
  margin: 0 10px;
}
.active {
  border-bottom: 2px solid @info-color;
  padding-bottom: 13px !important;
  color: @info-color;
}
.message-line {
  height: 1px;
  background: @font-color;
}
.message-i2 {
  background: @cont-bg;
  border-radius: 8px;
  padding: 15px 10px;
}
.ser-cont {
  padding: 10px;
  border-radius: 8px;
  background: @background-color;
}
</style>
